import { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { Box, Typography } from "@mui/material";
import { ConfigAccordionHeader } from "../../components/ConfigAccordionHeader/ConfigAccordionHeader";
import { IWorkOrderTemplateData } from "../ConfigWorkOrderTemplates.types";

export const WorkOrderSchedulingRulesTabView: FC<
  WorkOrderSchedulingRulesTabViewProps
> = () => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <ConfigAccordionHeader title="Scheduling Rules">
        <Typography variant="body2" color="text.secondary">
          Scheduling rules configuration coming soon.
        </Typography>
      </ConfigAccordionHeader>
    </Box>
  );
};

interface WorkOrderSchedulingRulesTabViewProps {
  form: UseFormReturn<IWorkOrderTemplateData>;
  extraTabProps?: {
    isReadOnly?: boolean;
  };
}
